import Vue from 'vue'
import {
  Form,
  FormItem,
  Input,
  Dialog,
  Upload,
  Tooltip,
  Message,
  Checkbox,
  CheckboxGroup,
  Popover,
  Select,
  RadioGroup,
  RadioButton,
  Option,
} from 'element-ui'

// import FilterDatePicker from '@/components/DatePicker'
// import '@/components/dgTable/css/index.css'
// Vue.use(FilterDatePicker)

const element = {
  install(Vue) {
    Vue.use(Form)
    Vue.use(FormItem)
    Vue.use(Input)
    Vue.use(Dialog)
    Vue.use(Upload)
    Vue.use(Tooltip)
    Vue.use(Checkbox)
    Vue.use(CheckboxGroup)
    Vue.use(Popover)
    Vue.use(Select)
    Vue.use(RadioGroup)
    Vue.use(RadioButton)
    Vue.use(Option)
    Vue.prototype.$message = Message
  },
}
export default element
